import Primarytheme from './theme';
import React, { useState, useEffect } from 'react';


import RecapLaunch from './RecapLaunch';
import DataUpload from './DataUpload';
import Options from './Options'
import History from '../History';

import Box from '@mui/material/Box';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Fade from "@mui/material/Fade";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Refresh from '@mui/icons-material/Refresh';
import SupportIcon from '@mui/icons-material/Support';
import Tooltip from "@mui/material/Tooltip";

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Process from './Process';
import AlertDialog from './AlertDialog';
import stepsObj from '../helpers/steps';
import RuleTable from './RuleTable';

import { getSessionIdToken } from '../auth/apiAuth'

import axios from 'axios';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: 0, //'1em',
    textAlign: 'left',
    //color: Primarytheme.palette.primary.main,
    fontSize: '16px',
    //fontWeight: 'bold',
    background: 'white',
    boxShadow: '0px 0px 0px 0px, 1px 1px 5px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%)',
    //border: '100px',
    //variant: 'outlined',
    borderRadius: '10px'
}));

const breaksLaunch = { xs: 320, sm: 450, md: 600, lg: 900, xl: 1350 };
const breaksHistory = breaksLaunch;


const {
    REACT_APP_USER_ID,
    REACT_APP_USER_POOL_ID,
} = process.env;

const stepRaw = [
    stepsObj.project,
    stepsObj.data,
    stepsObj.uploadRules
];

export default function GeoxRulesPage({ auth }) {

    const [parentForceRefresh, setParentForceRefresh] = useState(0);

    const [attachedProjects, setAttachedProjects] = useState(["geox/regole"]); // useState(auth.userState.attached_projects);

    const [conf, setConf] = useState({});

    const [launch, setLaunch] = useState({
        selectedProject: attachedProjects[0],
        fetching: false,
        tag: null,
        dataFormat: ['.csv', '.xlsx'],
        steps: stepRaw,
        activeStep: 0,
        isReady: false,
        isLoading: false,
        isLoaded: false,
        selectedFile: null,
        isTriggering: false,
        projectData: {},
        openSnack: false,
        launchMessage: '',
        error: undefined,
        firstStep: false,
    })

    const [snack, setSnack] = useState({
        open: false,
        launchMessage: ''
    })

    const [drawerOpen, setDrawerOpen] = useState(false);

    const [stepAppear, setStepAppear] = useState({
        'Project': true,
        'Process': false,
        'Data': true,
        'Options': false,
        'Upload and Validate': true
    });

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen)
    }

    const handleNext = () => {
        if (launch.activeStep === 0) {
            setLaunch({ ...launch, firstStep: true, activeStep: launch.activeStep + 1 });
        } else {
            setLaunch({ ...launch, activeStep: launch.activeStep + 1 })
        }
    };

    const handleBack = () => {
        setLaunch(launch => { return { ...launch, activeStep: launch.activeStep - 1, } })
    };

    const handleAbort = () => {
        handleStopProcess({ reqId: launch.projectData.reqId, project_id: conf.project_id })
            .then(resp => console.log('Abort'))
            .catch(err => console.error('Abort error'))
        handleClearProject();
        setLaunch(launch => { return { ...launch, activeStep: 0, } })
    }

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnack({ open: false, launchMessage: '' });
    };

    const handleChangeProject = (event, value) => {
        if (!value) handleClearProject();
        else setLaunch({ ...launch, fetching: true, selectedProject: value, error: undefined });
    };

    const handleChangeTag = (event) => {
        const tag = event.target.value;

        let flag_adminShowOptions = auth.userState.isAdmin;

        // change data upload format
        const dataFormat = conf.dataFormat ? conf.dataFormat[tag] || conf.dataFormat.default || launch.dataFormat : launch.dataFormat;

        const realPagOpts = conf.paginationOptions ? conf.paginationOptions.filter(opt => !opt.tags || opt.tags.indexOf(tag) !== -1) : [];
        const flag_isCurrOpts = launch.steps.filter(el => el.label === 'Options').length > 0;
        const updatedSteps = [...launch.steps];

        // change options choice
        // console.log('realPagOpts', realPagOpts);
        if (realPagOpts.length > 0) {
            setConf(conf => {
                conf.selectedPaginationOptions = realPagOpts
                return conf
            })
        }
        // reset options step
        if (!flag_adminShowOptions && realPagOpts.length > 0 && !flag_isCurrOpts) {
            updatedSteps.splice(-1, 0, stepsObj.options)
        }
        else if (!flag_adminShowOptions && realPagOpts.length === 0 && flag_isCurrOpts) updatedSteps.splice(-2, 1);

        //console.log('change options ', realPagOpts.length, flag_isCurrOpts)
        //console.log('data format ', dataFormat, conf.dataFormat)

        setLaunch(launch => {
            return {
                ...launch, tag,
                dataFormat,
                steps: updatedSteps,
                isLoading: false, isLoaded: false, selectedFile: null
            }
        })
    }

    const handleClearProject = () => {
        setStepAppear(stepAppear => { return { ...stepAppear, 'Options': false, 'Process': false, } })
        setLaunch(launch => {
            return {
                ...launch,
                selectedProject: undefined,
                dataFormat: ['.csv', '.xlsx'],
                fetching: false,
                steps: stepRaw,
                activeStep: 0,
                isReady: false,
                isLoaded: false,
                isLoading: false,
                tag: null,
                selectedFile: null,
                isTriggering: false,
                projectData: {},
                openSnack: false,
                launchMessage: '',
                error: undefined,
                firstStep: false,
            }
        })
        // setConf({}) // se faccio reset della conf non renderizza le regole attive
    };

    const handleStopProcess = async ({ reqId, project_id }) => {
        return axios.delete(`${process.env.REACT_APP_API_BASE_URL}/operations`, {
            headers: {
                "Authorization": await getSessionIdToken(),
                reqId,
                project_id,
                bucket: conf.bucket,
                user_id: 'web-app'
            }
        })


    }

    const handleTrigger = () => {
        console.log('triggering')
        setLaunch(launch => { return { ...launch, isTriggering: true } });
        triggerPagination({ auth, projectData: launch.projectData, conf, tag: launch.tag })
            .then(resp => {
                //console.log(resp.data)
                setSnack({ open: true, launchMessage: resp.data.message });
                setParentForceRefresh(parentForceRefresh => parentForceRefresh + 1);
                handleClearProject()
            })
            .catch(err => {
                console.error('triggering failed');
                setSnack({ open: true, launchMessage: `Launch failed. \n ${err}` });
                handleClearProject();
            })
    }


    const fetchConf = async ({ project_id }) => {
        const [customer, project_name] = project_id.split('/').slice(0, 2);
        //console.log(auth.userState.email)
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
            {
                headers: {
                    'user_id': auth.userState.user,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                    "project_id": project_id,
                    "project_name": project_name,
                    "customer": customer,
                }

            },
        );
    }

    const getOptions = (singleOpt) => {
        return new Promise((resolve, reject) => {
            auth.userState.s3.getObject({
                Bucket: singleOpt.s3List.split('/').shift(),
                Key: singleOpt.s3List.split('/').slice(1).join('/'),
            }, function (err, data) {
                if (err) reject(err);
                else resolve(JSON.parse(data.Body));
            });
        })
    }

    // update attached project once the user table is fetched
    useEffect(() => {
        //console.log('is fetching è cambiato ', auth.userState.isFetching)
        if (auth.userState.userItem) {
            setAttachedProjects(["geox/regole"]); // setAttachedProjects(auth.userState.attached_projects)
        }
    }, [auth]);

    // retrieve conf after selected project
    useEffect(() => {
        if (launch.selectedProject) {
            fetchConf({ project_id: launch.selectedProject })
                .then(response => {
                    const projectConf = response.data.projectConf;
                    if (!projectConf.paginationOptions) projectConf.paginationOptions = [];
                    if (!projectConf.project_status) projectConf.projectStatus = "";
                    if (!projectConf.tags) projectConf.tags = [];
                    if (!projectConf.custom_tags) projectConf.custom_tags = [];
                    if (!projectConf.deactivation) projectConf.deactivation = {};
                    if (!projectConf.assetFolder || !Array.isArray(projectConf.assetFolder)) projectConf.assetFolder = [];
                    if (!projectConf.indesignFolder || !Array.isArray(projectConf.indesignFolder)) projectConf.indesignFolder = [];
                    if (!projectConf.additionalDataFolder || !Array.isArray(projectConf.additionalDataFolder)) projectConf.additionalDataFolder = [];

                    // reset parameters
                    projectConf.internalTest = auth.userState.isAdmin ? true : false;
                    projectConf.doOnlyValidation = false;

                    const updatedSteps = [...stepRaw];


                    let flag_isTag = false;
                    let flag_showOptions = auth.userState.isAdmin;

                    if ((projectConf.tags.length > 0 || projectConf.limit_custom_tags) && updatedSteps.filter(el => el.label === 'Process').length === 0) {
                        flag_isTag = true;
                        updatedSteps.splice(1, 0, stepsObj.process)
                    }

                    if ((projectConf.paginationOptions.length > 0 || flag_showOptions) && updatedSteps.filter(el => el.label === 'Options').length === 0) {
                        updatedSteps.splice(-1, 0, stepsObj.options)
                        flag_showOptions = true;
                    }

                    setLaunch(launch => {
                        return { ...launch, fetching: false, steps: updatedSteps, dataFormat: projectConf.dataFormat ? projectConf.dataFormat.default : ['.csv', '.xlsx'] }
                    })
                    setStepAppear(stepAppear => { return { ...stepAppear, 'Options': flag_showOptions, Launch: true, 'Process': (projectConf.tags.length > 0 || projectConf.limit_custom_tags) } })

                    //manage options default
                    projectConf.selectedPaginationOptions = projectConf.paginationOptions.map(opt => {
                        if (opt.component === 'form-list') {
                            for (const block of opt.list) {
                                for (const singleBlock of block) {
                                    singleBlock.value = opt.persistent ? (singleBlock.value ? singleBlock.value : singleBlock.default) : singleBlock.default
                                }
                            }
                        }
                        else opt.value = opt.persistent ? (opt.value ? opt.value : opt.default) : opt.default;
                        return opt
                    });

                    // set list for autocomplete if s3List param is defined
                    for (const opt of projectConf.selectedPaginationOptions) {
                        if (opt.component === 'form-list') {
                            for (const block of opt.list) {
                                for (const singleOpt of block) {
                                    if (singleOpt.component === 'autocomplete') {
                                        if (singleOpt.s3List) {
                                            getOptions(singleOpt).then(data => {
                                                singleOpt.list = data;
                                                singleOpt.value = opt.persistent ? (singleOpt.value ? singleOpt.value : data[0]) : data[0];
                                            })
                                        }
                                    }
                                }
                            }
                        }
                        if (opt.component === 'autocomplete') {
                            if (opt.s3List) {
                                getOptions(opt).then(data => {
                                    opt.list = data;
                                    opt.value = opt.persistent ? (opt.value ? opt.value : data[0]) : data[0];
                                })
                            }
                        }
                    }

                    setConf(projectConf);
                })
                .catch(err => {
                    setLaunch({ ...launch, error: 'Error retrieving your project. Please contact support@pagination.com' })
                })
        }
    }, [launch.selectedProject, launch.firstStep]);


    // Component
    const StepperButtonsMove = ({ stepLabel }) => {

        let disabled, loading, onClick, color, endIcon;
        let label = 'next';

        switch (stepLabel) {
            case 'Project':
                disabled = !launch.selectedProject || !(auth.userState.isAdmin || !conf.disableLaunch);
                loading = launch.fetching;
                onClick = handleNext;
                break;
            case 'Process':
                disabled = !launch.tag;
                onClick = handleNext;
                break;
            case 'Data':
                disabled = !launch.isLoaded
                loading = launch.isLoading;
                onClick = handleNext;
                break;
            case 'Upload and Validate':
                disabled = !launch.isLoaded;
                loading = launch.isTriggering;
                onClick = handleTrigger;
                color = 'secondary';
                label = 'Upload and Validate';
                // endIcon = <RocketLaunchIcon />
                break;
            default:
                disabled = !launch.selectedProject;
                loading = false;
                onClick = handleNext;
                break;
        }


        if (launch.error) {
            return <Alert elevation={1} severity="error" sx={{ marginTop: '1em' }}><b>{launch.error}</b></Alert>
        }
        // usual buttons for the stepper
        else return (
            <Stack direction='column' spacing={2}>
                <Divider orientation="vertical" flexItem />
                <Stack sx={{ mb: 2 }} direction='row' justifyContent="space-between">
                    <Stack direction='row'>
                        <Button sx={{ mt: 1, mr: 1 }}
                            disabled={stepLabel === 'Project'}
                            onClick={handleBack} >
                            Back
                        </Button>
                        <AlertDialog
                            handleActionOnAgree={handleAbort}
                            title='Reset request'
                            text='Do you want to reset the request?'
                            buttonProps={{
                                sx: { mt: 1, mr: 1 },
                                disabled: stepLabel === 'Project',
                                label: 'Reset',
                                color: 'warning'
                            }}
                        />
                    </Stack>
                    <Button variant="contained" color={color}
                        loading={loading}
                        disabled={disabled}
                        onClick={onClick}>
                        {label}
                        {endIcon}
                    </Button>

                </Stack>
            </Stack>

        )
    }


    return (
        <Box m='2em'>
            <Grid
                container
                flexDirection={'row'}
                sx={{
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginTop: '1em',
                    marginBottom: '2em'
                }}
                rowSpacing={3}
                columnSpacing={3}
            >
                <Grid id='launch' size={12} >
                    <Item key='Stepper' sx={{ width: {...breaksLaunch}}}>
                        <Stack direction='row' justifyContent="space-between" >
                            <Typography variant='h5'
                                color={Primarytheme.palette.primary.main}
                                sx={{ marginBottom: '1em' }}>
                                <b>Caricamento Regole</b>
                            </Typography>
                            <Box>
                                <Tooltip title="knowledge base">
                                    <IconButton onClick={() => window.open('https://support.pagination.com/portal/en/kb/articles/geox-regole-2025', '_blank')} > <SupportIcon /> </IconButton>
                                </Tooltip>
                            </Box>
                        </Stack>
                        <Box >
                            <Stepper activeStep={launch.activeStep} orientation="horizontal" alternativeLabel>
                                {launch.steps.map((step, index) => (
                                    <Fade key={step.label} in={stepAppear[step.label]} >
                                        <Step sx={{
                                            '& .MuiStepLabel-root .Mui-completed': {
                                                color: Primarytheme.palette.secondary.main, // circle color (COMPLETED)
                                            },
                                            '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                            {
                                                color: 'black', // Just text label (COMPLETED)
                                            },
                                            '& .MuiStepLabel-root .Mui-active': {
                                                color: Primarytheme.palette.primary.main, // circle color (ACTIVE)
                                            },
                                            '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                            {
                                                color: 'black', // Just text label (ACTIVE)
                                            },
                                            /* '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                                fill: 'black', // circle's number (ACTIVE)
                                            }, */
                                        }}>
                                            <StepLabel >
                                                {step.label}
                                            </StepLabel>
                                        </Step>
                                    </Fade>
                                ))}
                            </Stepper>


                            <Box sx={{ marginTop: '2em', marginLeft: '2em', marginRight: '2em' }}>
                                {launch.steps[launch.activeStep].description}

                                {launch.steps[launch.activeStep].label === 'Project' &&
                                    <Autocomplete
                                        disablePortal
                                        id="project-selector"
                                        options={attachedProjects}
                                        sx={{ width: '100%', maxWidth: 400 }}
                                        clearOnEscape
                                        // defaultValue={attachedProjects.length === 1 ? attachedProjects[0] : ''}
                                        value={launch.selectedProject}
                                        onChange={handleChangeProject}
                                        size='small'
                                        renderInput={(params) => <TextField {...params} label="project" />}
                                    />
                                }
                                {launch.steps[launch.activeStep].label === 'Process' &&
                                    <Process launch={launch} conf={conf} setConf={setConf} handleChangeTag={handleChangeTag} auth={auth.userState.ssmParams} />

                                }
                                {launch.steps[launch.activeStep].label === 'Data' &&
                                    <DataUpload launch={launch} setLaunch={setLaunch} conf={conf} auth={auth.userState} handleStopProcess={handleStopProcess} />
                                }
                                {launch.steps[launch.activeStep].label === 'Options' && launch.selectedProject !== '' &&
                                    <Options conf={conf} launch={launch} setConf={setConf} tag={launch.tag} isAdmin={auth.userState.isAdmin} auth={auth.userState.ssmParams} />
                                }
                                {launch.steps[launch.activeStep].label === 'Upload and Validate' && launch.selectedProject !== '' &&
                                    <RecapLaunch launch={launch} conf={conf} />
                                }


                            </Box>

                            <StepperButtonsMove stepLabel={launch.steps[launch.activeStep].label} />

                            <Box>
                                <Snackbar
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    open={snack.open}
                                    autoHideDuration={6000}
                                    onClose={handleCloseSnack}
                                    message={snack.launchMessage}
                                    action={
                                        <React.Fragment>
                                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnack}>
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </React.Fragment>
                                    }
                                />
                            </Box>
                        </Box>
                    </Item>
                </Grid>
                <Grid id='recap' size={12}>
                    <Accordion expanded={drawerOpen} onChange={toggleDrawer} sx={{ width: {...breaksLaunch}}}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1bh-header" >
                            <Typography variant='h5' color={Primarytheme.palette.primary.main}>
                                <b>Recap Regole Attive</b>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack direction='column' justifyContent="space-between" >
                                <Typography variant='caption' sx={{ marginBottom: '0.5em' }}>
                                    Di seguito la lista delle regole caricate dei rispettivi progetti.<br />
                                    Le regole attive hanno il checkbox selezionato, le altre invece sono state caricate ma non attive.
                                </Typography>
                                <Alert elevation={1} severity="warning" sx={{ marginBottom: '1em' }}>
                                    Non è possibile cambiare lo stato delle regole attive in questa sezione. Per attivare/disattivare una regola seguire i passaggi in "Caricamento Regole".
                                </Alert>

                                <Stack direction='row' divider={<Divider sx={{ m: '0.5em' }} orientation="vertical" flexItem />}>
                                    {conf && conf.paginationOptions && conf.paginationOptions.map((opt, id) => {
                                        return (
                                            <Stack key={id} spacing={1} sx={{ width: '50%' }} alignItems="flex-start">
                                                <Typography variant='h5' color={Primarytheme.palette.primary.main} >
                                                    {opt.nome}
                                                </Typography>
                                                {opt.type === 'datafiles-list' && renderCheckBoxList(id, opt, conf, setConf)}
                                            </ Stack>
                                        )
                                    })}
                                </Stack>
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid id='requests' size={12}>
                    <Item key='Requests' sx={{ width: {...breaksHistory}}}>
                        <Stack direction='row' justifyContent="space-between" >
                            <Typography variant='h5' color={Primarytheme.palette.primary.main} >
                                <b>Storico Caricamenti</b>
                            </Typography>
                            <Box >
                                <IconButton onClick={() => setParentForceRefresh(parentForceRefresh => parentForceRefresh + 1)} > <Refresh /> </IconButton>
                            </Box>
                        </Stack>

                        <History auth={auth} parentForceRefresh={parentForceRefresh} inDashBoard={true} forceProjectList={attachedProjects} forceLayout={'rules'} />
                    </Item>
                </Grid>
            </Grid >
        </Box >
    )


}

const renderCheckBoxList = (id, opt, conf, setConf) => {
    return <Stack direction='column' alignItems='left' spacing={2} key={opt.nome + '2'}>
        {opt.type === 'datafiles-list' && opt.list && opt.list.map((file, idFile) => (
            <Stack direction='column' alignItems='left' justifyContent={'flex-start'} key={opt.nome + '3' + idFile}>
                <FormControlLabel
                    label={file.name}
                    key={file.name}
                    control={<Checkbox
                        key={file.name + 'check'}
                        checked={file.value}
                    /* onChange={(e) => handleChangeCheckOptionList(id, idFile, e.target.checked, conf, setConf)} */
                    />}
                />
                <Typography sx={{ ml: '2.5em' }} variant='caption' key={file.name + 'date'} >
                    {file.dateUpload}
                </Typography>
                {/* {file.name !== currentFileName && (
                    <Stack direction='row' alignItems='left' key={opt.nome + '4' + idFile}>
                        <Tooltip title="Cancella regola">
                            <IconButton key={file.name + 'del'} sx={{ padding: '0.5em' }} size="small" onClick={async () => await deleteCheckBoxItem(id, idFile, opt, file, auth)} ><DeleteIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Download regola">
                            <IconButton size="small" sx={{ padding: '0.5em' }} onClick={() => getFileFromS3({ key: file.dataPath, bucket: file.bucket, attachment: true, ssmParams: auth })}>
                                < DescriptionIcon fontSize="small" />
                            </IconButton>
                        </ Tooltip >
                    </Stack>
                )} */}
            </Stack>
        ))}
    </Stack>
}

const handleChangeCheckOptionList = (idOpt, idBlock, newValue, conf, setConf) => {
    // console.log(idOpt, newValue)
    const newConf = { ...conf };
    newConf.selectedPaginationOptions[idOpt].list[idBlock].value = newValue;
    // console.log('update', newConf.selectedPaginationOptions[idOpt].list[idBlock])
    setConf(newConf);
}


async function triggerPagination({ auth, projectData, conf, tag }) {

    const pagOptionsToSend = !conf.selectedPaginationOptions ? [] : conf.selectedPaginationOptions.map(opt => {
        return {
            ...opt,
            value: opt.value !== undefined ? opt.value : opt.default
        }
    });

    // attach tag to pagination options
    if (tag) pagOptionsToSend.push({ nome: 'tag', value: tag });


    //console.log('triggering')
    return axios.post(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
        {
            "project_id": conf.project_id,
            "project_name": conf.project_name,
            "reqId": projectData.reqId,
            "email": auth.userState.email,
            "user_id": auth.user,
            "customer": conf.customer,
            "bucket": conf.bucket,
            "prefix": conf.project_id,
            "dataFolder": projectData.dataFolder,
            "key": encodeURIComponent(projectData.key),
            "projectConf": conf,
            "paginationOptions": pagOptionsToSend,
            "internalTest": conf.internalTest,
            "doOnlyValidation": conf.doOnlyValidation
        },
        {
            headers: {
                'user_id': auth.userState.user,
                "content-type": "application/json",
                "Authorization": await getSessionIdToken(),
            }

        },
    );
}